import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableConsumerSearch = loadable(() => import('./ConsumerSearch'), {
  fallback: <LoadingScreen />,
});

export const AdditionalVerification = loadable(
  () => import('./AdditionalVerification'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableConsumerSearch;
